import React from 'react';
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';

export const bugsnagClient = bugsnag('da08d829ef30edcef8a5d3f9db85f3a7');
bugsnagClient.use(bugsnagReact, React);